<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <util-keys @keyup.ctrl.shift.48="shortcutFill(true)" />
        <util-keys @keyup.ctrl.shift.57="shortcutFill(false)" />
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div class="lg:mb-4">
            </div>
            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <AccessibleElSelect
                v-model="form.ClienteID"
                prop="ClienteID"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="newnotification"
              >
                <template slot="label"><base-obligatory-icon/>{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.EmpresaID"
                prop="EmpresaID"
                :options="companiesForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="isSelectClientEmpty"
                id-prefix="newnotification"
              >
                <template slot="label"><base-obligatory-icon/>{{$t('app.company')}}</template>
              </AccessibleElSelect>
            </div>
            <div class="lg:mb-2">
            </div>
            <div class="flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <AccessibleElSelect
                  v-model="form.SedeID"
                  prop="SedeID"
                  :options="sedesForAccessibleSelect"
                  :withFormItem="true"
                  :isDisabled="isSelectClientEmpty || isSelectEmpresaEmpty"
                  id-prefix="newnotification"
                  @change="handleSedeChange"
                >
                  <template slot="label"><base-obligatory-icon/>{{$t('app.location')}}</template>
                </AccessibleElSelect>
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <AccessibleElSelect
                  v-model="form.TipoNotificacion"
                  prop="TipoNotificacion"
                  :options="tiposNotificacionForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="newnotification"
                >
                  <template slot="label"><base-obligatory-icon/>{{$t('app.type')}}</template>
                </AccessibleElSelect>
              </div>
            </div>
            <div class="flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0 " v-if="!this.newOrganismoActive">
                <AccessibleElSelect
                  v-model="form.OrganismoID"
                  prop="OrganismoID"
                  :options="organismosForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="newnotification"
                  :remote="true"
                  :remoteMethod="remoteOrganismos"
                  popperClass="wrap-select-popover"
                  :loading="loadingOrganismos"
                >
                  <template slot="label">
                    <div class="flex flex-row items-center">
                      <base-obligatory-icon/>{{$t('app.organismo_cif')}}
                      <base-tooltip-icon size="sm" :content="contenTooltipOrganismosSearch" class="ml-2 mb-2"/>
                    </div>
                  </template>
                </AccessibleElSelect>
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0" v-if="this.newOrganismoActive">
                <div class="flex flex-row items-center">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.new_organismo')}}</label>
                  <base-tooltip-icon size="sm" :content="contenTooltipOrganismosCreate" class="ml-2 mb-2"/>
                </div>
                  <el-form-item prop="newOrganismo" >
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.newOrganismo"
                      maxlength='250'
                    />
                  </el-form-item>
              </div>
              <div class="px-2 w-72 mb-4 lg:mb-0 lg:mt-8">
                <!-- <label class="text-sm font-semibold text-secondary-600 block mb-3"> &nbsp; </label> -->
                <base-button v-if="!this.newOrganismoActive" class="mt-1" icon="plus" mode="primary" :text="$t('app.organismo_create')" @click.native.prevent="changeInputOrganismo"/>
                <base-button v-else class="mt-1" mode="primary" icon="lens" :text="$t('app.organismo_search')" @click.native.prevent="changeInputOrganismo"/>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.subject')}}
                  <el-form-item prop="Asunto">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Asunto"
                      maxlength='500'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.TicketID')}}
                <el-form-item prop="TicketID">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.TicketID"
                    maxlength='250'>
                    <template slot="prepend">{{ preTagSede }}</template>
                  </el-input>
                </el-form-item>
              </label>
            </div>

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.Estado"
                prop="Estado"
                :options="estadosNEOFilterForAccessibleSelect"
                :withFormItem="true"
                id-prefix="newnotification"
                @change="handleStatusChange"
              >
                <template slot="label"><base-obligatory-icon/>{{$t('app.status')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full flex items-center">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('notificationFilter.disposition_date')}}
                  <el-form-item prop="FechaPublicacion">
                    <el-date-picker
                      :clearable="false"
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.FechaPublicacion"
                      type="datetime"
                      format="dd-MM-yyyy HH:mm:ss"
                      placeholder="dd-MM-aaaa HH:mm:ss"
                      :picker-options="dateRangeOptions"
                      ref="datePickerFechaPublicacion"
                      @blur="onBlurDatePickerMixin('.datePickerFechaPublicacion-popover')"
                      @focus="onFocusDatePickerMixin('.datePickerFechaPublicacion-popover')"
                      @keydown.native="captureKeyNotChrome"
                      popper-class="datePickerFechaPublicacion-popover"
                      >
                    </el-date-picker>
                  </el-form-item>
                </label>
                <base-clear-input-button
                  v-if="form.FechaPublicacion"
                  aria-label="Limpiar fecha"
                  @clear="form.FechaPublicacion = null"
                />
              </div>
              <div class="px-2 w-full flex items-center">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.end_date')}}
                  <el-form-item prop="FechaFinTramite">
                    <el-date-picker
                      :clearable="false"
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.FechaFinTramite"
                      type="date"
                      format="dd-MM-yyyy"
                      placeholder="dd-mm-aaaa"
                      :picker-options="dateRangeOptions"
                      ref="datePickerFechaFinTramite"
                      @blur="onBlurDatePickerMixin('.datePickerFechaFinTramite-popover')"
                      @focus="onFocusDatePickerMixin('.datePickerFechaFinTramite-popover')"
                      @keydown.native="captureKeyNotChrome"
                      popper-class="datePickerFechaFinTramite-popover"
                      >
                    </el-date-picker>
                  </el-form-item>
                </label>
                <base-clear-input-button
                  v-if="form.FechaFinTramite"
                  aria-label="Limpiar fecha"
                  @clear="form.FechaFinTramite = null"
                />
              </div>
              <div v-if="this.form.Estado === 2 || this.form.Estado === 13" class="px-2 w-full flex items-center">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.date_download')}}
                  <el-form-item prop="FechaDescarga">
                    <el-date-picker
                      :clearable="false"
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.FechaDescarga"
                      type="datetime"
                      format="dd-MM-yyyy HH:mm:ss"
                      placeholder="dd-MM-aaaa HH:mm:ss"
                      :picker-options="dateRangeOptions"
                      ref="datePickerFechaDescarga"
                      @blur="onBlurDatePickerMixin('.datePickerFechaDescarga-popover')"
                      @focus="onFocusDatePickerMixin('.datePickerFechaDescarga-popover')"
                      @keydown.native="captureKeyNotChrome"
                      popper-class="datePickerFechaDescarga-popover"
                      >
                    </el-date-picker>
                  </el-form-item>
                </label>
                <base-clear-input-button
                  v-if="form.FechaDescarga"
                  aria-label="Limpiar fecha"
                  @clear="form.FechaDescarga = null"
                />
              </div>
            </div>

            <div class="mb-6">
              <label for="switch-new-neo-send_alerts" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('companies.send_alerts')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.active')}}</span>
              </label>
              <el-switch 
                id="switch-new-neo-send_alerts"
                :aria-label="$t('companies.send_alerts')"
                class="switch-text break-normal mt-2" 
                v-model="form.EnviarEmail" 
                :active-text="$t('configurations.active')" 
                />
            </div>

            <div v-if="this.form.Estado === 2 || this.form.Estado === 13">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4"><base-obligatory-icon/>Documento principal PDF</h2>
              <div class="flex -mx-2 flex-col lg:flex-row mb-2">
                <div class="px-2 mb-2 lg:mb-0">
                  <el-form-item prop="fileMain" ref="fileMainRef">
                    <Upload
                      role="button"
                      ref="uploadMain"
                      id="fileMainSelector"
                      class="bg-white dark:bg-darkblue-900"
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      action="#"
                      accept="application/pdf"
                      :auto-upload=false
                      :on-progress="handleProgress"
                      :on-preview="handlePreview"
                      :on-remove="handleRemoveMain"
                      :limit="1"
                      :on-change="handleChangeMain"
                      :on-exceed="handleOnExceedMain"
                      >
                      <i class="el-icon-upload"></i>
                      <p v-if="fileMain.length" class="el-upload__text"><em>{{this.fileNameMain}}</em></p>
                      <div v-else class="el-upload__text">Suelta tus archivos aquí o <em>haz clic para cargar</em></div>
                    </Upload>
                  </el-form-item>
                </div>
              </div>
              <div class="flex items-center">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">Documentos de la notificación</h2>
                <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
              </div>
              <div class="flex -mx-2 flex-col lg:flex-row mb-2">
                <div class="px-2 mb-2 lg:mb-0">
                  <el-form-item prop="file" ref="fileRef">
                    <Upload
                      role="button"
                      ref="upload"
                      id="fileSelector"
                      class="bg-white dark:bg-darkblue-900 "
                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                      drag
                      multiple
                      action="#"
                      :auto-upload=false
                      :on-progress="handleProgress"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :limit="this.maxFiles"
                      :on-change="handleChange"
                      :on-exceed="handleOnExceed"
                      >
                      <i class="el-icon-upload"></i>
                      <p v-if="file.length" class="el-upload__text"><em>{{this.fileName}}</em></p>
                      <div v-else class="el-upload__text">Suelta tus archivos aquí o <em>haz clic para cargar</em></div>
                    </Upload>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Metadatos adicionales</h2>
              <el-table
                ref="metadatos"
                :data="form.Metadatos"
                style="width: 100%"
                show-header>
                <el-table-column
                  prop="Campo"
                  label="Campo"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="Valor"
                  label="Valor"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  width="80"
                  align="center"
                  label="-">
                  <template slot-scope="scope">
                  <div class="flex flex-row">
                    <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar metadato" />
                  </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="w-full m-2 float-right">
              <base-button-responsive
                v-if="this.form.ClienteID"
                mode="primary"
                :text="$t('notificationFilter.new_metadata')"
                @click="newMetadato()"
                icon="plus"
                class="m-5 float-right"
              />
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.cancel')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <notification-new-metadata-dialog 
        :dialogOpen="showNewMetadato" 
        :idCliente="this.form.ClienteID"
        @toggleDialog="toggleDialogMetadato" 
        @applyDialog="applyDialogMetadatoHandler"
      />
    </template>
  </detail-layout>
</template>

<script>
import moment from 'moment'
import { Upload } from 'element-ui'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'

import { newNotification } from '@/services/app/newNotification'
// import { subirAnexo } from '@/services/notifications/subirAnexo'

import { getAllCompanies } from '@/services/companies/getAllCompanies'
import { getSedesVinculadasByEmpresa } from '@/services/app/getSedesVinculadasByEmpresa'
import { getOrganismosAll } from '@/services/configurations/getOrganismosAll'
import { ESTADOS_NEO_ALTA } from '@/config/estados-neo-alta'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJUNTOS } from '@/config/extensiones-adjuntos'
import UtilKeys from '@/components/utilities/UtilKeys'
import { v4 as uuidv4 } from 'uuid'

import NotificationNewMetadataDialog from '@/components/NotificationNewMetadataDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'new-notification',
  components: {
    DetailLayout,
    Upload,
    UtilKeys,
    NotificationNewMetadataDialog,
    AccessibleElSelect,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      contenTooltipOrganismosSearch: 'Escriba para iniciar la búsqueda y seleccionar un organismo ya existente. Si el organismo deseado no se encuentra en la lista, pulse "Nuevo organismo" para poder crearlo.',
      contenTooltipOrganismosCreate: 'Escriba el nombre del organismo a crear. Si desea crear la notificación con un organismo existene pulse "Buscar existente" para seleccionarlo.',
      sedeManual: {
        codigo: 'Manual',
        label: 'Sede Manual',
        value: 0
      },
      numMaxMetadatos: 20,
      showNewMetadato: false,
      isLoadingInitial: false,
      showGeneratePassword: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'NUEVA NOTIFICACIÓN',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'notifications'
      },
      estadosNEO: ESTADOS_NEO_ALTA,
      form: this.getDefaultForm(),
      clientes: [],
      tiposNotificacion: [],
      companies: [],
      sedes: [],
      organismos: [],
      loadingOrganismos: false,
      maxFiles: 14,
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJUNTOS,
      fileMain: [],
      file: [],
      newRules: {
        ClienteID: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        EmpresaID: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        SedeID: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        Asunto: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        TicketID: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        Estado: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        TipoNotificacion: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        FechaPublicacion: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        FechaDescarga: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        OrganismoID: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
          // { required: false, validator: this.validateOrganismos, trigger: 'blur' }
        ],
        newOrganismo: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        fileMain: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                this.doAriaLiveAndReturnCallback(i18n.t('app.fill_data'), callback)
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.$i18n.t('validation.not_pdf'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain || this.fileNameMain.length < 5 || this.fileNameMain.substr(this.fileNameMain.length - 4).toUpperCase() !== '.PDF') {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          },
        ],
        file: [
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                if (!this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                this.doAriaLiveAndReturnCallback(this.extensionRuleMessage, callback)
              } else {
                callback()
              }
            }
          },
        ]
      },
      newOrganismoActive: false,
    }
  },
  computed: {
    empresaFilter () {
      return this.$store.getters['notifications/getMasterFilters']?.empresa?.value || null
    },
    estadosNEOFilter () {
      if (this.isSedeAMano) return this.estadosNEO.filter(x => x.id !== 0)
      return this.estadosNEO
    },
    extensionRuleMessage: function () {
      return i18n.t('validation.not_extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    extensionTooltipMessage: function () {
      return 'Número máximo de ficheros: ' + this.maxFiles + '. ' +
      i18n.t('validation.extension') + this.extensionesAdjuntosPermitidas.join(', ')
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isSedeAMano () {
      return this.form !== undefined && this.form !== null && this.form.SedeID === this.sedeManual.value
    },
    preTagSede () {
      // return 'DEV'
      if (this.form.SedeID === undefined || this.form.SedeID === null || this.form.SedeID === '') return 'Sede_'
      if (this.form.SedeID === 1) return ''
      return this.sedes.filter(x => x.value === this.form.SedeID)[0].codigo + '_'
    },
    fileNameMain () {
      if (this.fileMain === null || this.fileMain.length === 0) {
        return ''
      } else if (this.fileMain.length === 1) {
        return this.fileMain[0].name
      } else {
        return '(' + this.fileMain.length + ') Archivos'
      }
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return '(' + this.file.length + ') Archivos'
      }
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    getIdEmpresaLogged: function () {
      return this.$store.getters['auth/user'].idEmpresa
    },
    ifFormEmpty: function () {
      return this.form === undefined || this.form === undefined
    },
    isSelectClientEmpty: function () {
      return this.isFormEmpty || this.form.ClienteID === null || this.form.ClienteID === undefined || this.form.ClienteID === ''
    },
    isSelectEmpresaEmpty: function () {
      return this.isFormEmpty || this.form.EmpresaID === null || this.form.EmpresaID === undefined || this.form.EmpresaID === ''
    },
    isSelectSedeEmpty: function () {
      return this.isFormEmpty || this.form.SedeID === null || this.form.SedeID === undefined || this.form.SedeID === ''
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    },
    companiesForAccessibleSelect () {
      return this.companies.map(empresa => ({
        id: empresa.value,
        name: empresa.label,
        value: empresa.value
      }))
    },
    sedesForAccessibleSelect () {
      return this.sedes.map(sede => ({
        id: sede.value,
        name: sede.label,
        value: sede.value
      }))
    },
    tiposNotificacionForAccessibleSelect () {
      return this.tiposNotificacion.map(tipo => ({
        id: tipo.id,
        name: tipo.valor,
        value: tipo.id
      }))
    },
    organismosForAccessibleSelect () {
      return this.organismos.map(organismo => ({
        id: organismo.id,
        name: organismo.label,
        value: organismo.id
      }))
    },
    estadosNEOFilterForAccessibleSelect () {
      return this.estadosNEOFilter.map(estado => ({
        id: estado.id,
        name: estado.name,
        value: estado.id
      }))
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.FechaPublicacion': {
      deep: true,
      handler: 'watchFechaPublicacionHandler'
    },
    'form.FechaFinTramite': {
      deep: true,
      handler: 'watchFechaFinTramiteHandler'
    },
    'form.FechaDescarga': {
      deep: true,
      handler: 'watchFechaDescargaHandler'
    },
    'form.ClienteID': {
      deep: true,
      handler: 'watchClienteIDHandler'
    },
    'form.EmpresaID': {
      deep: true,
      handler: 'watchEmpresaIDHandler'
    },
    'form.Estado': {
      deep: true,
      handler: 'watchEstadoHandler'
    }
    // 'form.SedeID': {
    //   deep: true,
    //   handler: 'watchSedeIDHandler'
    // }
  },
  created: async function () {
    this.isLoadingInitial = true
    const breadcrumbs = []
    breadcrumbs.push({
      path: 'notifications',
      name: this.$i18n.t('app.notifications')
    })
    breadcrumbs.push({
      path: '',
      name: this.$i18n.t('app.new_notification')
    })
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      this.preSelectClient(this.form, 'ClienteID')
    } else {
      this.form.ClienteID = this.getIdEmpresaLogged
    }
    await this.$store.dispatch('app/getNotificationsTypes')
    this.tiposNotificacion = await this.$store.getters['app/notificationsTypes']
    this.header.breadcrumb = breadcrumbs
    this.isLoadingInitial = false
  },
  mounted () {
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    shortcutFill (descargada = true) {
      this.doFeedback('Atajo detectado. Rellenando formulario con datos de prueba.', 'info')
      const guid = uuidv4()
      console.log('Guid generado', guid)
      this.form.TicketID = guid
      this.form.Asunto = guid
      if (descargada) this.form.Estado = 2
      else this.form.Estado = 0
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
        this.form.ClienteID = this.clientes[this.clientes.length - 1].IdEmpresa
      }
      this.organismos = [{
        id: 18585,
        label: 'AEAT',
        value: 'AEAT',
      }]
      setTimeout(() => {
        this.form.EmpresaID = this.companies[this.companies.length - 1].value
        setTimeout(() => {
          this.form.SedeID = 0
          this.form.FechaPublicacion = '2023-01-01 10:00:00'
          if (descargada) this.form.FechaDescarga = '2023-01-02 10:00:00'
          this.form.TipoNotificacion = 1
          this.form.OrganismoID = 18585
        }, 500)
      }, 500)
    },
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    changeInputOrganismo: function () {
      this.newOrganismoActive = !this.newOrganismoActive
      this.form.newOrganismo = ''
      this.form.OrganismoID = null
      this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
    },
    handleOnExceedMain: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + 1 + ')', 'warning')
    },
    handleOnExceed: function () {
      this.doFeedback('Se ha superado el número máximo de ficheros (' + this.maxFiles + ')', 'warning')
    },
    handleChangeMain: function (file) {
      this.$refs.fileMainRef.clearValidate()
      this.fileMain.push(file)
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemoveMain: function (file) {
      this.fileMain = this.fileMain.filter(x => x.uid !== file.uid)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    getDefaultForm: function () {
      return {
        id: -1,
        TicketID: '',
        Asunto: '',
        ClienteID: null,
        EmpresaID: null,
        SedeID: null,
        Estado: null,
        FechaPublicacion: '',
        FechaFinTramite: '',
        Metadatos: [],
        FechaDescarga: '',
        EnviarEmail: false,
        TipoNotificacion: null,
        OrganismoID: null,
        newOrganismo: ''
      }
      // return {
      //   id: -1,
      //   TicketID: 'Autogenerado',
      //   Asunto: 'Autogenerado',
      //   ClienteID: 281,
      //   EmpresaID: 2667,
      //   SedeID: 2,
      //   Estado: 0,
      //   FechaPublicacion: '2023-06-09 13:13:13',
      //   FechaFinTramite: '2023-06-30',
      //   FechaDescarga: '',
      //   TipoNotificacion: 1,
      //   OrganismoID: 4306,
      //   newOrganismo: ''
      // }
    },
    watchFechaPublicacionHandler: async function () {
      if (this.form.FechaPublicacion !== undefined && moment(this.form.FechaPublicacion).isValid()) {
        this.form.FechaPublicacion = moment(this.form.FechaPublicacion).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.form.FechaPublicacion = ''
      }
    },
    watchFechaFinTramiteHandler: async function () {
      if (this.form.FechaFinTramite !== undefined && moment(this.form.FechaFinTramite).isValid()) {
        this.form.FechaFinTramite = moment(this.form.FechaFinTramite).format('YYYY-MM-DD')
      } else {
        this.form.FechaFinTramite = ''
      }
    },
    watchFechaDescargaHandler: async function () {
      if (this.form.FechaDescarga !== undefined && moment(this.form.FechaDescarga).isValid()) {
        this.form.FechaDescarga = moment(this.form.FechaDescarga).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.form.FechaDescarga = ''
      }
    },
    watchClienteIDHandler: async function () {
      if (!this.isLoadingInitial) this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
      this.form.EmpresaID = null
      this.companies = []
      if (this.form.ClienteID !== undefined && this.form.ClienteID !== null && this.form.ClienteID !== '') {
        const data = await getAllCompanies({ idEmpresaCert: this.form.ClienteID })
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          data.CIFSEmpresa.forEach(row => {
            this.companies.push({ value: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.NombreCIF })
          })
        }
      }
    },
    watchEmpresaIDHandler: async function () {
      if (!this.isLoadingInitial) this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
      this.form.SedeID = null
      this.sedes = []
      if (this.form.EmpresaID !== undefined && this.form.EmpresaID !== null && this.form.EmpresaID !== '') {
        const data = await getSedesVinculadasByEmpresa({ idCIFEmpresa: this.form.EmpresaID })
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          this.sedes.push(this.sedeManual)
          data.respuesta.forEach(row => {
            this.sedes.push({ value: row.IdPGN, label: row.Nombre, codigo: row.Codigo })
          })
        }
      }
    },
    watchEstadoHandler: async function () {
      if (!this.isLoadingInitial) this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
    },
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    newMetadato: async function () {
      this.toggleDialogMetadato()
    },
    applyDialogMetadatoHandler (payload) {
      try {
        this.$store.commit('app/setLoading', true)
        if (this.form.Metadatos.length >= this.numMaxMetadatos) {
          this.doFeedback(`Se ha superado el número máximo de metadatos adicionales (${this.numMaxMetadatos})`)
        } else if (this.form.Metadatos.filter(x => x.Campo === payload.Campo).length > 0) {
          this.doFeedback('Ya se ha añadido un metadato adicional con ese campo')
        } else {
          this.form.Metadatos.push({
            Campo: payload.Campo,
            Valor: payload.Valor,
          })
          this.toggleDialogMetadato()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        this.form.Metadatos = this.form.Metadatos.filter(x => x.Campo !== row.Campo)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    submitForm: function (formName) {
      this.newNEOHandler(formName)
    },
    newNEOHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            const allFiles = this.fileMain.concat(this.file)
            const listaNEOAdjuntos = []
            const listPromises = []
            // Ejemplo promesas multiples asincronas con espera final de todas
            allFiles.forEach((file) => {
              listPromises.push(this.getBase64(file.raw)
                .then(res => {
                  const b64 = res.split(',')[1]
                  listaNEOAdjuntos.push({
                    Base64: b64,
                    Nombre: file.name
                  })
                }))
            })
            await Promise.all(listPromises)
            const objNEO = {
              idEmpresa: this.form.ClienteID,
              IdCIFEmpresa: this.form.EmpresaID,
              IdPGN: this.form.SedeID,
              TipoNotificacion: this.form.TipoNotificacion,
              idOrganismo: this.form.OrganismoID,
              Organismo: this.form.newOrganismo,
              Asunto: this.form.Asunto,
              TicketID: this.form.TicketID,
              EstadoDescarga: this.form.Estado,
              FechaPublicacion: this.form.FechaPublicacion,
              FechaFinTramite: this.form.FechaFinTramite,
              MetadatosAdicionales: this.form.Metadatos,
              FechaDescargaOficial: this.form.FechaDescarga,
              EnviarEmail: this.form.EnviarEmail,
              ListaNEOAdjuntos: (this.form.Estado === 2 || this.form.Estado === 13) 
                ? listaNEOAdjuntos
                : null,
            }
            const responseNEO = await newNotification(objNEO)
            if (responseNEO.blnError === true) {
              this.doFeedback(responseNEO.msgError + ' [Código de error: ' + responseNEO.codError + ']')
            } else {
              this.showOKAndClean()
              this.resetControlFormChanges()
              if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
                this.preSelectClient(this.form, 'ClienteID')
              }
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        } catch (error) {
          console.error(error)
          this.doFeedback()
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    getBase64Sync: async function (file) {
      const result_base64 = await new Promise((resolve) => {
        const fileReader = new FileReader()
        fileReader.onload = (e) => resolve(fileReader.result)
        fileReader.readAsDataURL(file)
      }) 

      // console.log('b64', result_base64) // aGV5IHRoZXJl...

      return result_base64
    },
    showOKAndClean () {
      this.isLoadingInitial = true
      this.doFeedback('Notificación dada de alta correctamente', 'success')
      if (this.form.Estado === 2 || this.form.Estado === 13) {
        this.$refs.uploadMain.clearFiles()
        this.$refs.upload.clearFiles()
      }
      this.resetForm()
      this.form = this.getDefaultForm()
      if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'SuperAdministrador') {
        this.form.ClienteID = this.getIdEmpresaLogged
      }
      this.fileMain = []
      this.file = []
      setTimeout(() => {
        this.isLoadingInitial = false
      }, 500)
    },
    goBack: function () {
      // this.notifyWindows('EdasNEO', '5 Notificaciones puestas a disposición')
      this.$router.push({ name: 'notifications' })
    },
    handleStatusChange: function () {
      this.form.FechaDescarga = null
      this.file = []
    },
    handleSedeChange: function () {
      if (this.isSedeAMano) this.form.Estado = null
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.organismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosAll({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.organismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
